import { createFileRoute } from '@tanstack/react-router'

import { CommunicationsPage } from '#/modules/communication/communications-page'

export const Route = createFileRoute('/_shell/communications')({
  component: CommunicationsPage,
})
